/*!
  * @license MIT (https://github.com/geotrev/omdomdom/blob/master/LICENSE)
  * Omdomdom v0.3.2 (https://github.com/geotrev/omdomdom)
  * Copyright 2023 George Treviranus <geowtrev@gmail.com>
  */
var DATA_KEY_ATTRIBUTE$1 = "data-key";
var hasProperty = function hasProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
};
var keyIsValid = function keyIsValid(map, key) {
  if (!key) return false;
  if (hasProperty(map, key)) {
    console.warn("[OmDomDom]: Children with duplicate keys detected. Children with duplicate keys will be skipped, resulting in dropped node references. Keys must be unique and non-indexed.");
    return false;
  }
  return true;
};
var forEach = function forEach(items, fn) {
  var length = items.length;
  var idx = -1;
  if (!length) return;
  while (++idx < length) {
    if (fn(items[idx], idx) === false) break;
  }
};
var createKeyMap = function createKeyMap(children) {
  var map = {};
  forEach(children, function (child) {
    var key = child.attributes[DATA_KEY_ATTRIBUTE$1];
    if (keyIsValid(map, key)) {
      map[key] = child;
    }
  });
  for (var _ in map) {
    return map;
  }
};
var insertBefore = function insertBefore(parent, child, refNode) {
  return parent.node.insertBefore(child.node, refNode);
};
var assignVNode = function assignVNode(template, vNode) {
  for (var property in template) {
    vNode[property] = template[property];
  }
};

var toHTML = function toHTML(htmlString) {
  var processedDOMString = htmlString.trim().replace(/\s+</g, "<").replace(/>\s+/g, ">");
  var parser = new DOMParser();
  var context = parser.parseFromString(processedDOMString, "text/html");
  return context.body;
};

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var Types = {
  STRING: "string",
  INT: "number",
  BOOL: "boolean"
};
var DomProperties = {};
var createRecord = function createRecord(attrName, propName, type) {
  return {
    attrName: attrName,
    propName: propName,
    type: type
  };
};
var stringProps = [["style", "cssText"], ["class", "className"]];
forEach(stringProps, function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    attr = _ref2[0],
    property = _ref2[1];
  DomProperties[attr] = createRecord(attr, property || attr, Types.STRING);
});
var booleanProps = ["autofocus", "draggable", "hidden", "checked", "multiple", "muted", "selected"];
forEach(booleanProps, function (attr) {
  DomProperties[attr] = createRecord(attr, attr, Types.BOOL);
});
var integerProps = [["tabindex", "tabIndex"]];
forEach(integerProps, function (_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
    attr = _ref4[0],
    property = _ref4[1];
  DomProperties[attr] = createRecord(attr, property, Types.INT);
});
var Namespace = {
  xlink: {
    prefix: "xlink:",
    resource: "http://www.w3.org/1999/xlink"
  },
  xml: {
    prefix: "xml:",
    resource: "http://www.w3.org/XML/1998/namespace"
  }
};

var setProperty = function setProperty(element, type, prop, value) {
  switch (type) {
    case Types.STRING:
      {
        if (prop === DomProperties.style.propName) {
          if (value === null) {
            element.style[prop] = "";
          } else {
            element.style[prop] = value;
          }
        } else if (value === null) {
          element[prop] = "";
        } else {
          element[prop] = value;
        }
        break;
      }
    case Types.INT:
      {
        if (value === null) {
          var attr = prop.toLowerCase();
          element.removeAttribute(attr);
        } else if (value === "0") {
          element[prop] = 0;
        } else if (value === "-1") {
          element[prop] = -1;
        } else {
          var parsed = parseInt(value, 10);
          if (!isNaN(parsed)) {
            element[prop] = parsed;
          }
        }
        break;
      }
    case Types.BOOL:
      {
        if (["", "true"].indexOf(value) < 0) {
          element[prop] = false;
        } else {
          element[prop] = true;
        }
        break;
      }
  }
};

var removeAttributes = function removeAttributes(vNode, attributes) {
  forEach(attributes, function (attrName) {
    if (hasProperty(DomProperties, attrName)) {
      var propertyRecord = DomProperties[attrName];
      setProperty(vNode.node, propertyRecord.type, propertyRecord.propName, null);
    } else {
      if (attrName in vNode.node) {
        setProperty(vNode.node, Types.STRING, attrName, null);
      }
      vNode.node.removeAttribute(attrName);
    }
    delete vNode.attributes[attrName];
  });
};
var setAttributes = function setAttributes(vNode, attributes) {
  for (var attrName in attributes) {
    var value = attributes[attrName];
    vNode.attributes[attrName] = value;
    if (hasProperty(DomProperties, attrName)) {
      var propertyRecord = DomProperties[attrName];
      setProperty(vNode.node, propertyRecord.type, propertyRecord.propName, value);
      continue;
    }
    if (attrName.startsWith(Namespace.xlink.prefix)) {
      vNode.node.setAttributeNS(Namespace.xlink.resource, attrName, value);
      continue;
    }
    if (attrName.startsWith(Namespace.xml.prefix)) {
      vNode.node.setAttributeNS(Namespace.xml.resource, attrName, value);
      continue;
    }
    if (attrName in vNode.node) {
      setProperty(vNode.node, Types.STRING, attrName, value);
    }
    vNode.node.setAttribute(attrName, value || "");
  }
};
var getPropertyValues = function getPropertyValues(element, attributes) {
  for (var attrName in DomProperties) {
    var propertyRecord = DomProperties[attrName];
    var propName = propertyRecord.propName;
    var attrValue = element.getAttribute(attrName);
    if (attrName === DomProperties.style.attrName) {
      attributes[attrName] = element.style[propName];
    } else if (typeof attrValue === "string") {
      attributes[attrName] = attrValue;
    }
  }
};
var getBaseAttributes = function getBaseAttributes(element) {
  return Array.prototype.reduce.call(element.attributes, function (attributes, attrName) {
    if (!hasProperty(DomProperties, attrName.name)) {
      attributes[attrName.name] = attrName.value;
    }
    return attributes;
  }, {});
};
var getAttributes = function getAttributes(element) {
  var attributes = getBaseAttributes(element);
  getPropertyValues(element, attributes);
  return attributes;
};
var updateAttributes = function updateAttributes(template, vNode) {
  var removedAttributes = [];
  var changedAttributes = {};
  for (var attrName in vNode.attributes) {
    var oldValue = vNode.attributes[attrName];
    var nextValue = template.attributes[attrName];
    if (oldValue === nextValue) continue;
    if (typeof nextValue === "undefined") {
      removedAttributes.push(attrName);
    }
  }
  for (var _attrName in template.attributes) {
    var _oldValue = vNode.attributes[_attrName];
    var _nextValue = template.attributes[_attrName];
    if (_oldValue === _nextValue) continue;
    if (typeof _nextValue !== "undefined") {
      changedAttributes[_attrName] = _nextValue;
    }
  }
  removeAttributes(vNode, removedAttributes);
  setAttributes(vNode, changedAttributes);
};

var DATA_KEY_ATTRIBUTE = "data-key";
function patchChildren(template, vNode, patch) {
  var templateChildrenLength = template.children.length;
  var vNodeChildrenLength = vNode.children.length;
  if (!templateChildrenLength && !vNodeChildrenLength) return;
  var vNodeKeyMap = createKeyMap(vNode.children);
  var nextChildren = Array(templateChildrenLength);
  if (vNodeKeyMap !== undefined) {
    forEach(template.children, function (templateChild, idx) {
      var childNodes = vNode.node.childNodes;
      var key = templateChild.attributes[DATA_KEY_ATTRIBUTE];
      if (Object.prototype.hasOwnProperty.call(vNodeKeyMap, key)) {
        var keyedChild = vNodeKeyMap[key];
        if (Array.prototype.indexOf.call(childNodes, keyedChild.node) !== idx) {
          insertBefore(vNode, keyedChild, childNodes[idx]);
        }
        nextChildren[idx] = keyedChild;
        delete vNodeKeyMap[key];
        patch(templateChild, nextChildren[idx]);
      } else {
        insertBefore(vNode, templateChild, childNodes[idx]);
        nextChildren[idx] = templateChild;
      }
    });
  } else {
    forEach(template.children, function (templateChild, idx) {
      var vNodeChild = vNode.children[idx];
      if (typeof vNodeChild !== "undefined") {
        patch(templateChild, vNodeChild);
        nextChildren[idx] = vNodeChild;
      } else {
        vNode.node.appendChild(templateChild.node);
        nextChildren[idx] = templateChild;
      }
    });
  }
  vNode.children = nextChildren;
  var childNodesLength = vNode.node.childNodes.length;
  var delta = childNodesLength - templateChildrenLength;
  if (delta > 0) {
    while (delta > 0) {
      vNode.node.removeChild(vNode.node.childNodes[childNodesLength - 1]);
      childNodesLength--;
      delta--;
    }
  }
}

var patch = function patch(template, vNode, rootNode) {
  if (!template || !vNode) return;
  rootNode = rootNode || vNode.node.parentNode;
  var contentChanged = template.content && template.content !== vNode.content;
  if (template.type !== vNode.type || contentChanged) {
    rootNode.replaceChild(template.node, vNode.node);
    return assignVNode(template, vNode);
  }
  updateAttributes(template, vNode);
  patchChildren(template, vNode, patch);
};
var render = function render(vNode, root) {
  root.appendChild(vNode.node);
};
var create = function create(node) {
  var isSVGContext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (typeof node === "string") {
    node = toHTML(node);
  }
  var isRoot = node.tagName === "BODY";
  var childNodes = node.childNodes;
  var numChildNodes = childNodes ? childNodes.length : 0;
  if (isRoot) {
    if (numChildNodes > 1) {
      throw new Error("[OmDomDom]: Your element should not have more than one root node.");
    } else if (numChildNodes === 0) {
      throw new Error("[OmDomDom]: Your element should have at least one root node.");
    } else {
      return create(childNodes[0]);
    }
  }
  var type = node.nodeType === 3 ? "text" : node.nodeType === 8 ? "comment" : node.tagName.toLowerCase();
  var isSVG = isSVGContext || type === "svg";
  var attributes = node.nodeType === 1 ? getAttributes(node) : {};
  var content = numChildNodes > 0 ? null : node.textContent;
  var children = Array(numChildNodes);
  forEach(childNodes, function (child, idx) {
    children[idx] = create(child, isSVG);
  });
  return {
    type: type,
    attributes: attributes,
    children: children,
    content: content,
    node: node,
    isSVGContext: isSVG
  };
};

export { create, patch, render };
//# sourceMappingURL=omdomdom.es.js.map
